import VendorClaimsGenericSuccessModal from "./VendorClaimsGenericSuccessModal";
import styled from "styled-components";

const StyledVendorClaimsGenericSuccessModal = styled(VendorClaimsGenericSuccessModal)`
  .confirmation-container {
    min-height: 40vh;
    max-height: 45vh;
    width: 75rem;
    margin: 0 3rem 0 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default StyledVendorClaimsGenericSuccessModal;
